



























import Vue, { PropType } from 'vue';
import CourseModal from './coursemodal/CourseModal.vue';
import {
    CourseraCollection as CourseraCollectionType,
    CourseraCourse,
    CourseraProgram,
} from '~/models/coursera';
import CourseraCollection from './CourseraCollection.vue';

export default Vue.extend({
    name: 'CourseraBody',
    components: {
        CourseModal,
        CourseraCollection,
    },
    props: {
        program: {
            type: Object as PropType<CourseraProgram>,
            required: true,
        },
        searchedCourse: {
            type: Object as PropType<CourseraCourse | null>,
            default: null,
        },
        hasAccess: Boolean,
    },
    data() {
        return {
            modalCourse: null as CourseraCourse | null,
        };
    },
    computed: {
        openCourse(): CourseraCourse | null {
            return this.searchedCourse || this.modalCourse;
        },
        collections(): CourseraCollectionType[] {
            return this.program.collections.filter(c => !!c.title.trim());
        },
    },
    methods: {
        setOpenCourse(course: CourseraCourse | null) {
            this.modalCourse = course;
        },
        handleCloseModal() {
            this.setOpenCourse(null);
            this.$emit('close-course');
        },
    },
});
